<template lang="pug">
  .footer
    span.info-terms APLICA SOLO PARA REGISTROS MERCANTIL Y ENTIDADES SIN ANIMO DE LUCRO
    a.terms-btn(href='/docs/terms.pdf', target='_blank') TERMINOS Y CONDICIONES    
    span.copy © 2019
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
  .dev
    text-align: center
    z-index: 2
  .footer
    background: transparent
    position: relative
    width: 100%
    display: flex
    flex-direction: column
    align-items: center
    color: #fff
    padding-top: 0
    transform: skewY(5deg)
    &:after, &:before
      width: 140px
      height: 140px
      position: absolute
      background-size: cover !important
      background-repeat: no-repeat !important
      background-position: center !important
    &:after
      content: ''
      background: url(../../../images/starts.svg)
      top: -40px
      left: 0
    &:before
      content: ''
      background: url(../../../images/starts.svg)
      bottom: 40px
      right: 31px
      transform: rotate(157deg)
  .players
  .info-terms
    font-weight: 300
    font-size: 1rem
    text-align: center
  a
    margin-bottom: 20px
    display: inline-block
    color: #fff
    font-weight: bold
  .terms-btn
    margin: 20px 0
    background: #fcbf00
    border: 0
    padding: 20px
    font-weight: bold
    color: #4f4f4f
    border-radius: 5px
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2)
    outline: none
</style>



// WEBPACK FOOTER //
// resources/js/components/PageConcurso2019/FooterMatricula.vue